import { render, staticRenderFns } from "./lp-details-panel.vue?vue&type=template&id=77226836&"
import script from "./lp-details-panel.vue?vue&type=script&lang=js&"
export * from "./lp-details-panel.vue?vue&type=script&lang=js&"
import style0 from "./lp-details-panel.vue?vue&type=style&index=0&id=77226836&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports